module.exports = __webpack_public_path__ + "media/checkout/cart-03d60af8.webp";